<template>
  <div class="container-fluid h-100">
    <div class="content-userData" id="content1-register">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <div class="col-12 col-md-12 col-lg-6 col-xl-7 col-sm-12">
          <div class="row p-row mt-3">
            <div class="col-12 small-info">
              <small>INFORMACIÓN DEL USUARIO PROPIETARIO DEL CARNET</small>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Tipo de documento</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.document_type_name }}</strong></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Número de documento</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.document_number }}</strong></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Nombres</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.name }}</strong></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Apellidos</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.last_name }}</strong></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Departamento</strong></h6>
                <div class="input-group  mb-3">
                  <span><strong>{{ userData.state_name }}</strong></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Ciudad</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.city_name }}</strong></span>
                </div>
              </div>
            </div>
            <div v-if="userData.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px"><strong>Placa</strong></h6>
                <div class="input-group mb-3">
                  <span><strong>{{ userData.plate }}</strong></span>
                </div>
              </div>
            </div>
            <!-- <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Dirección *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Teléfono *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Email *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Género *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Marca de tu moto *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="dataUser.motorcycle_brands_id == 44 && dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">¿Cúal? *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Cilindraje de tu moto *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">Uso de tu moto *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
              v-if="dataUser.motorcycle_uses_id == 4"
            >
              <div class="form-group">
                <h6 style="text-align:left; font-size:15px">¿Cúal? *</h6>
                <div class="input-group mb-3">
                  <span></span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "userDataAlliance",

  data() {
    return {
      userData: [],
    };
  },
  methods: {
    getDataUser(){
      var app = this;
      const id = parseInt(app.$route.params.id);

      axios
      .get('api/alliance/user/' + id)
      .then(function(res) {
        if(res.data.cod == 0){
          app.userData = res.data.data;
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "success",
            title: "Excelente",
            text: res.data.message,
          });
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: res.data.message,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },
  },
  mounted(){
    this.getDataUser();
  },
};
</script>

<style scoped>
.content-userData {
  padding: 5%;
}
.table-register {
  margin-left: 10%;
}
.small-register {
  font-family: "GothamBoldItalic", sans-serif !important;
}
.club {
  font-size: 55px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.password-text {
  font-family: "GothamBoldItalic", sans-serif;
}
.ingresa {
  font-size: 18px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.condiciones {
  text-align: left !important;
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
.font-none {
  font-family: "Arial", sans-serif;
}
.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-select {
  font-size: 13px;
  height: 30px !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  color: #fff !important;
  font-size: 32px !important;
  padding-bottom: 30px;
}
.input-group span{
  color: #dc3545;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .color-input {
    padding: 0px 15px !important;
  }
  .content-userData {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-userData {
    height: 100%;
  }
  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .table-register {
    margin-left: 0%;
  }
  .content-userData {
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .club {
    font-size: 40px;
    text-align: left;
  }
  .ingresa {
    font-size: 18px;
    text-align: left;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
  .small-info {
    text-align: center !important;
    font-size: 25px !important;
  }
  .form-group h6{
    text-align: center !important;
  }
  .input-group span{
    text-align: center !important;
    min-width: 100%;
    color: #dc3545;
  }
}
</style>
